import React from 'react';
import _ from 'lodash';
import { array, func } from 'prop-types';
import { useTranslation } from 'react-i18next';

const TopDrugsNew = ({ drugsObj, handleDrugClick }) => {
  const { i18n } = useTranslation();
  return (
    <section className="top-drugs">
      <article>
        {!_.isEmpty(drugsObj?.title) && (
          <h2 className="top-drugs-heading">{drugsObj?.title}</h2>
        )}
        <ul>
          {!_.isEmpty(drugsObj?.drugs) &&
            drugsObj?.drugs.map((item, id) => {
              return (
                <li key={id}>
                  <a
                    href={`${_.withLocale(i18n.language, '/prescription')}/${
                      item.seoName
                    }`}
                    onClick={e => handleDrugClick(e, item.seoName)}
                    className="whiteFocus"
                  >
                    {item.name}
                  </a>
                </li>
              );
            })}
        </ul>
      </article>
    </section>
  );
};

TopDrugsNew.propTypes = {
  drugs: array,
  handleDrugClick: func
};

TopDrugsNew.defaultProps = {
  drugs: [],
  handleDrugClick: () => {}
};

export default TopDrugsNew;
